<template>
    <table class="soil-report-results">
        <thead>
            <tr>
                <th colspan="10" class="border-0 bg-transparent"></th>
                <th colspan="8" class="bg-transparent font-print-xs">NEUTRAL AMMONIUM ACETATE (EXCHANGEABLE)</th>
                <th colspan="8" class="border-0 bg-transparent"></th>
            </tr>
            <tr>
                <th rowspan="4">LAB NUMBER</th>
                <th rowspan="4">SAMPLE<br>IDENTIFICATION</th>
                <th colspan="2" rowspan="2" class="border-bottom-0">ORGANIC<br>MATTER</th>
                <th colspan="6">PHOSPHORUS</th>
                <th colspan="2" class="border-bottom-0">POTASSIUM</th>
                <th colspan="2" class="border-bottom-0">MAGNESIUM</th>
                <th colspan="2" class="border-bottom-0">CALCIUM</th>
                <th colspan="2" class="border-bottom-0">SODIUM</th>
                <th colspan="2">pH</th>
                <th rowspan="3" class="border-bottom-0">CATION<br>EXCHANGE<br>CAPACITY<br>C.E.C.</th>
                <th colspan="5">PERCENT BASE SATURATION (COMPUTED)</th>
            </tr>
            <tr>
                <th colspan="2" class="border-bottom-0">P<sub>1</sub></th>
                <th colspan="2" class="border-bottom-0">P<sub>2</sub></th>
                <th colspan="2" class="border-bottom-0">BICARBONATE<br>P</th>
                <th colspan="2" rowspan="2" class="border-bottom-0 border-top-0">K</th>
                <th colspan="2" rowspan="2" class="border-bottom-0 border-top-0">Mg</th>
                <th colspan="2" rowspan="2" class="border-bottom-0 border-top-0">Ca</th>
                <th colspan="2" rowspan="2" class="border-bottom-0 border-top-0">Na</th>
                <th rowspan="2" class="border-bottom-0">SOIL<br>pH</th>
                <th rowspan="3">BUFFER<br>INDEX</th>
                <th rowspan="2" class="border-bottom-0">K</th>
                <th rowspan="2" class="border-bottom-0">Mg</th>
                <th rowspan="2" class="border-bottom-0">Ca</th>
                <th rowspan="2" class="border-bottom-0">H</th>
                <th rowspan="2" class="border-bottom-0">Na</th>
            </tr>
            <tr>
                <th colspan="2" class="border-top-0 border-bottom-0">L.O.I.</th>
                <th colspan="2" class="border-top-0 border-bottom-0 font-print-xs text-nowrap">WEAK BRAY<br>1:7</th>
                <th colspan="2" class="border-top-0 border-bottom-0 font-print-xs text-nowrap">STRONG BRAY<br>1:7</th>
                <th colspan="2" class="border-top-0 border-bottom-0 font-print-xs">OLSEN</th>
            </tr>
            <tr>
                <th class="border-top-0 border-right-0">%</th>
                <th class="border-top-0 border-left-0">RATE</th>
                <template v-for="n in 7">
                    <th class="border-top-0 border-right-0">ppm</th>
                    <th class="border-top-0 border-left-0">RATE</th>
                </template>
                <th class="border-top-0">1:1</th>
                <th class="border-top-0">meq/100g</th>
                <th class="border-top-0">%</th>
                <th class="border-top-0">%</th>
                <th class="border-top-0">%</th>
                <th class="border-top-0">%</th>
                <th class="border-top-0">%</th>
            </tr>
        </thead>

        <tbody>
            <tr class="text-center" v-for="(sample, sample_index) in samples">
                <td>{{ sample.id || '&nbsp;' }}</td>
                <td>{{ sample.client_id }}</td>
                <td>{{ getResult(sample_index, 'OM') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'OM Rate') }}</td>
                <td>{{ getResult(sample_index, 'P1') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'P1 Rate') }}</td>
                <td>{{ getResult(sample_index, 'P2') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'P2 Rate') }}</td>
                <td>{{ getResult(sample_index, 'BICARB') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'BICARB Rate') }}</td>
                <td>{{ getResult(sample_index, 'K') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'K Rate') }}</td>
                <td>{{ getResult(sample_index, 'MG') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'MG Rate') }}</td>
                <td>{{ getResult(sample_index, 'CA') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'CA Rate') }}</td>
                <td>{{ getResult(sample_index, 'NA') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'NA Rate') }}</td>
                <td>{{ getResult(sample_index, 'PH') }}</td>
                <td>{{ getResult(sample_index, 'BPH') }}</td>
                <td>{{ getResult(sample_index, 'CEC') }}</td>
                <td>{{ getResult(sample_index, 'PERCENTK') }}</td>
                <td>{{ getResult(sample_index, 'PERCENTMG') }}</td>
                <td>{{ getResult(sample_index, 'PERCENTCA') }}</td>
                <td>{{ getResult(sample_index, 'PERCENTH') }}</td>
                <td>{{ getResult(sample_index, 'PERCENTNA') }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script type="text/ecmascript-6">
    export default{
        props: {
            samples: { default() { return [] }}
        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {
            getResult (sample_index, analysis) {
                let sample = _.has(this.samples, sample_index) ? this.samples[sample_index] : {}

                return _.has(sample, [analysis, 'value']) ? sample[analysis].value : null;
            }
        },
        mounted () {

        }
    }
</script>



// WEBPACK FOOTER //
// ResultsTable1.vue?727f01ea